import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private store: StorageService) {}

  canActivate(): boolean {
    if (this.store.data.apikey) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
} 